import { render, staticRenderFns } from "./ChangeMedioSectorTable.vue?vue&type=template&id=9c0c56be&scoped=true"
import script from "./ChangeMedioSectorTable.vue?vue&type=script&lang=js"
export * from "./ChangeMedioSectorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0c56be",
  null
  
)

export default component.exports